export const FacilityCardList = [
  {
    title: "TownHouse",
    icon: "town",
    img: "town",
  },
  {
    title: "canteen",
    icon: "canteen",
    img: "canteen",
  },
  {
    title: "travel",
    icon: "travel",
    img: "travel",
  },
  {
    title: "Guest House",
    icon: "guest",
    img: "guest",
  },
  {
    title: "Stationary",
    icon: "stationary",
    img: "stationary",
  },
  {
    title: "Conference Room",
    icon: "room",
    img: "room",
  },
];
